import React, { Suspense, useEffect } from "react";
import "@/i18n/translate"; // 번역 훅
import { useLang } from '@/i18n/useLang'
import { Box } from '@mui/material'
import AppHeader from './layout/AppHeader';
import AppFooter from './layout/AppFooter';
import AppRoutes from './routes/AppRoutes';
import { ThemeProvider, CssBaseline } from '@mui/material';

import { LoadingProvider } from '@components/LoadingProvider';
import { ConfirmProvider } from '@components/ConfirmProvider';
import { AuthProvider } from '@components/AuthContext';
import ScrollToTop from '@components/ScrollToTop';
import PageLoader from '@components/PageLoader';
import { ScrollTopButton } from '@components/ScrollTopButton';
import theme from './theme';

const SkipLink = () => (
  <a
    href="#main-content"
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      padding: '8px 16px',
      background: '#000',
      color: '#fff',
      zIndex: 9999,
      transform: 'translateY(-120%)',
    }}
    onFocus={(e) => {
      e.target.style.transform = 'translateY(0)'
    }}
    onBlur={(e) => {
      e.target.style.transform = 'translateY(-120%)'
    }}
  >
    본문 바로가기
  </a>
)

const App = () => {
  const lang = useLang() 
  useEffect(() => {
    document.documentElement.lang = lang
  }, [lang])
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <ConfirmProvider>
        <AuthProvider>
          <LoadingProvider>
            <Box
              sx={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <SkipLink />
              
              <AppHeader />
              <PageLoader />
              <ScrollToTop />
              
              <Box 
                component="main"
                id="main-content"
                sx={{ 
                  flex: 1, 
                  display: 'flex', 
                  flexDirection: 'column' 
                }}
              >
                <Suspense fallback={null}>
                  <AppRoutes />
                </Suspense>
              </Box>

              <AppFooter />
              <ScrollTopButton />
            </Box>
          </LoadingProvider>
        </AuthProvider>
      </ConfirmProvider>
    </ThemeProvider>
  );
};

export default App;
